import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';

/**
 * Redirect component for old monthly inspection route format
 * Handles: /monthly_inspections/{reportId}/edit/{period?}
 * Redirects to: /properties/{propertyId}/reports/monthly_inspections/{reportId}/edit/{period?}
 */
const MonthlyInspectionRedirect = () => {
  const { reportId, period } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectToCorrectRoute = async () => {
      try {
        console.log('🔄 [REDIRECT] Looking up property ID for monthly inspection report:', reportId);
        
        // Fetch the report to get property_id
        const response = await api.get(`/monthlyinspectionreports/${reportId}`);
        const report = response.data?.data || response.data;

        if (report && report.property_id) {
          const propertyId = report.property_id;
          const redirectPath = period 
            ? `/properties/${propertyId}/reports/monthly_inspections/${reportId}/edit/${period}`
            : `/properties/${propertyId}/reports/monthly_inspections/${reportId}/edit`;
          
          console.log('✅ [REDIRECT] Redirecting to:', redirectPath);
          navigate(redirectPath, { replace: true });
        } else {
          console.error('❌ [REDIRECT] Report not found or missing property_id');
          navigate('/properties', { replace: true });
        }
      } catch (error) {
        console.error('❌ [REDIRECT] Error looking up report:', error);
        // Fallback: redirect to properties list
        navigate('/properties', { replace: true });
      }
    };

    redirectToCorrectRoute();
  }, [reportId, period, navigate]);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Redirecting to monthly inspection report...</p>
    </div>
  );
};

export default MonthlyInspectionRedirect;

